/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/scholarship-tab",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500
    >,
    GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna a lista de bolsas vinculadas à matrícula com tipo, status e desconto, para exibição na aba Detalhe de Bolsa do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna dados de bolsa de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/scholarship-tab}
 */
export function useGetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab<
  TData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
